import * as actionTypes from './actionTypes';

export const actions = {
  originFilter: function filterAdded(val) {
    return {
      type: actionTypes.ORIGIN_FILTER_ADDED,
      payload: {
        filter: val
      }
    };
  },

  destinationFilter: function destinAdded(val) {
    return {
      type: actionTypes.DESTIN_FILTER_ADDED,
      payload: {
        filter: val
      }
    };
  },

  destinationOptions: function optionsUpdated(val) {
    return {
      type: actionTypes.DESTINATION_OPTIONS_UPDATED,
      payload: {
        options: val
      }
    };
  },

  flightNumFilter: function filterAdded(val) {
    return {
      type: actionTypes.FNUM_FILTER_ADDED,
      payload: {
        filter: val
      }
    };
  },

  flights: function flightsAdded(val) {
    return {
      type: actionTypes.FLIGHTS_ADDED,
      payload: {
        flights: val
      }
    };
  },

  resetFilters: function resetTriggered() {
    return {
      type: actionTypes.RESET_TRIGGERED
    };
  }
};



// WEBPACK FOOTER //
// ./src/widgets/FlightStatus/actions.js